// extracted by mini-css-extract-plugin
module.exports = {"sc-rich-text":"RichText_sc-rich-text__EsrXh","spacing-tight":"RichText_spacing-tight__vWQZJ"};